import { NavLink, useNavigate } from "react-router-dom";
import JobZImage from "../../../../common/jobz-img";
import { admin, adminRoute, canRoute, candidate, empRoute, employer, publicUser } from "../../../../../globals/route-names";
import { useState } from "react";
import { useAuth } from "../../../../../context/AuthContext";

function LoginPage() {
    const navigate = useNavigate();
    const { login, register } = useAuth();
    const [mode, setMode] = useState("login");
    const [role, setRole] = useState("candidate");
    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: ""
    });
    const [visible, setVisible] = useState({
        password: false,
        confirmPassword: false
    });
    const [status, setStatus] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const update = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };

    const destinationFor = (user) => {
        if (user.role === "admin") return adminRoute(admin.DASHBOARD);
        if (user.role === "employer") return empRoute(employer.DASHBOARD);
        return canRoute(candidate.DASHBOARD);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        setStatus("");

        if (mode === "register") {
            if (form.password.length < 6) {
                setStatus("Password must be at least 6 characters.");
                setSubmitting(false);
                return;
            }
            if (form.password !== form.confirmPassword) {
                setStatus("Passwords do not match. Please re-enter the same password.");
                setSubmitting(false);
                return;
            }
        }

        try {
            const user = mode === "login"
                ? await login({ email: form.email, password: form.password })
                : await register({ name: form.name, email: form.email, password: form.password, role });
            navigate(destinationFor(user));
        } catch (error) {
            setStatus(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className="section-full site-bg-white">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-8 col-lg-6 col-md-5 twm-log-reg-media-wrap">
                            <div className="twm-log-reg-media">
                                <div className="twm-l-media">
                                    <JobZImage src="images/login-bg.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-7">
                            <div className="twm-log-reg-form-wrap">
                                <div className="twm-log-reg-logo-head">
                                    <NavLink to={publicUser.HOME1}>
                                        <JobZImage src="images/zozojobs-logo.png" alt="Zozo Jobs" className="logo" />
                                    </NavLink>
                                </div>
                                <div className="twm-log-reg-inner">
                                    <div className="twm-log-reg-head">
                                        <div className="twm-log-reg-logo">
                                            <span className="log-reg-form-title">{mode === "login" ? "Log In" : "Create Account"}</span>
                                        </div>
                                    </div>

                                    <div className="twm-tabs-style-2">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button className={`nav-link ${mode === "login" ? "active" : ""}`} type="button" onClick={() => setMode("login")}>
                                                    <i className="fas fa-right-to-bracket" />Login
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button className={`nav-link ${mode === "register" ? "active" : ""}`} type="button" onClick={() => setMode("register")}>
                                                    <i className="fas fa-user-plus" />Register
                                                </button>
                                            </li>
                                        </ul>

                                        <form onSubmit={handleSubmit} className="p-t30">
                                            {mode === "register" && (
                                                <>
                                                    <div className="form-group mb-3">
                                                        <input
                                                            name="name"
                                                            type="text"
                                                            required
                                                            className="form-control"
                                                            placeholder="Full name*"
                                                            value={form.name}
                                                            onChange={update}
                                                        />
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <select className="form-control" value={role} onChange={(event) => setRole(event.target.value)}>
                                                            <option value="candidate">Candidate</option>
                                                            <option value="employer">Employer</option>
                                                        </select>
                                                    </div>
                                                </>
                                            )}
                                            <div className="form-group mb-3">
                                                <input
                                                    name="email"
                                                    type="email"
                                                    required
                                                    className="form-control"
                                                    placeholder="Email address*"
                                                    value={form.email}
                                                    onChange={update}
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <PasswordField name="password" placeholder="Password*" value={form.password} onChange={update} visible={visible.password} onToggle={() => setVisible({ ...visible, password: !visible.password })} />
                                            </div>
                                            {mode === "register" && (
                                                <div className="form-group mb-3">
                                                    <PasswordField name="confirmPassword" placeholder="Re-enter password*" value={form.confirmPassword} onChange={update} visible={visible.confirmPassword} onToggle={() => setVisible({ ...visible, confirmPassword: !visible.confirmPassword })} />
                                                    <PasswordMatch password={form.password} confirmPassword={form.confirmPassword} />
                                                </div>
                                            )}
                                            {status && <div className="alert alert-danger">{status}</div>}
                                            <div className="form-group">
                                                <button type="submit" disabled={submitting} className="site-button">
                                                    {submitting ? "Please wait..." : mode === "login" ? "Log in" : "Register"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function PasswordField({ name, placeholder, value, onChange, visible, onToggle }) {
    return (
        <div className="position-relative">
            <input
                name={name}
                type={visible ? "text" : "password"}
                className="form-control"
                required
                minLength={6}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                style={{ paddingRight: 44 }}
            />
            <button
                type="button"
                className="btn btn-link position-absolute top-50 end-0 translate-middle-y text-muted"
                onClick={onToggle}
                aria-label={visible ? "Hide password" : "Show password"}
            >
                <i className={visible ? "fa fa-eye-slash" : "fa fa-eye"} />
            </button>
        </div>
    );
}

function PasswordMatch({ password, confirmPassword }) {
    if (!confirmPassword) return <small className="text-muted">Re-enter your password to confirm.</small>;
    if (password === confirmPassword) return <small className="text-success">Passwords match.</small>;
    return <small className="text-danger">Passwords do not match.</small>;
}

export default LoginPage;
